export class NotaValidator {

  static isNotaValid(nota: number): { valid: boolean, message?: string } {
    if (nota === null || nota === undefined || Number.isNaN(nota)) {
      return { valid: false, message: 'Nota inválida.' }
    }

    // Verifica se está entre 0 e 10
    if (nota < 0 || nota > 10) {
      return { valid: false, message: 'A nota deve estar entre 0 e 10.' }
    }

    // Verifica se possui mais de 2 casas decimais
    const casasDecimais = nota.toString().split('.')[1]
    if (casasDecimais && casasDecimais.length > 2) {
      return { valid: false, message: 'A nota deve ter no máximo 2 casas decimais.' }
    }

    return { valid: true }
  }
}
